import { APTOS_SEPARATOR } from "./constants.js";
export const unusedNonce = 0;
export const unusedArbiterFee = 0n;
export const _platform = "Aptos";
/**
 * Test if given string is a valid fully qualified type of moduleAddress::moduleName::structName.
 * @param str String to test
 * @returns Whether or not given string is a valid type
 */
export const isValidAptosType = (str) => /^(0x)?[0-9a-fA-F]+::\w+::\w+$/.test(str);
/**
 * Returns module address from given fully qualified type/module address.
 * @param str FQT or module address
 * @returns Module address
 */
export const coalesceModuleAddress = (str) => str.split(APTOS_SEPARATOR)[0];
//# sourceMappingURL=types.js.map